import { render, staticRenderFns } from "./salesWagesExportExcel.vue?vue&type=template&id=777b1020&scoped=true&"
import script from "./salesWagesExportExcel.vue?vue&type=script&lang=js&"
export * from "./salesWagesExportExcel.vue?vue&type=script&lang=js&"
import style0 from "./salesWagesExportExcel.vue?vue&type=style&index=0&id=777b1020&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777b1020",
  null
  
)

/* custom blocks */
import block0 from "./salesWagesExportExcel.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports